import axios from "./HTTP";

export default {
  addEmployee(params, callback) {
    axios
      .post(`/api/geotags/${params.tagID}/add-employees`, {
        employeeIDs: params.employeeIDs
      })
      .then(response => {
        callback(response.data);
      });
  },

  removeEmployee(params, callback) {
    axios
      .delete(
        `/api/geotags/${params.tagID}/remove-employee/${params.employeeID}`
      )
      .then(response => {
        callback(response.data);
      });
  },

  getAll(callback) {
    axios
      .get("/api/geotags.json")
      .then(response => callback(response.data.geoTags));
  },

  create(params, callback, errorCallback) {
    axios
      .post(`/api/geotags.json`, {
        segment: params
      })
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  removeWorksiteFrom(params, callback, errCallback) {
    const { worksiteID, tagID } = params;
    axios
      .post(`/api/geotags/${tagID}/remove-worksite`, {
        worksiteID: params.worksiteID,
        tagID: params.tagID
      })
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        errCallback(error);
      });
  },

  addWorksitesTo(params, callback, errCallback) {
    const { worksiteIDs, tagID } = params;
    axios
      .post(`/api/geotags/${tagID}/add-worksites`, {
        worksiteIDs: params.worksiteIDs,
        tagID: params.tagID
      })
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        errCallback(error);
      });
  },

  updateMembers(params, callback, errorCallback) {
    axios
      .patch(`/api/geotags/${params.tagID}/members.json`, {
        member_segment_ids: params.memberSegmentIDs
      })
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  delete(id, callback, errorCallback) {
    axios
      .delete(`/api/geotags/${id}.json`)
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  }
};
